import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

import { useDeleteAccountLink, type AccountDetailLink } from "../../api";

const REL_LABEL: Record<string, string> = {
  merged_into: "Merged into",
  split_from: "Split from",
  subcustomer_of: "Sub-customer of",
  continuation_of: "Continuation of",
};

export function RemoveLinkDialog({
  link,
  open,
  onOpenChange,
}: {
  link: AccountDetailLink | null;
  open: boolean;
  onOpenChange: (v: boolean) => void;
}) {
  const del = useDeleteAccountLink();
  if (!link) return null;
  return (
    <Dialog open={open} onOpenChange={(v) => !del.isPending && onOpenChange(v)}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Remove account link?</DialogTitle>
          <DialogDescription>
            Remove the <b>{REL_LABEL[link.relationship] ?? link.relationship}</b> link between
            QB-{link.source_qb_id} and QB-{link.target_qb_id}? After removal, the source account
            returns to its normal churn and pipeline behavior.
          </DialogDescription>
        </DialogHeader>
        <div className="flex justify-end gap-2">
          <Button
            variant="outline"
            onClick={() => onOpenChange(false)}
            disabled={del.isPending}
          >
            Cancel
          </Button>
          <Button
            variant="destructive"
            onClick={async () => {
              try {
                await del.mutateAsync(link.id);
                onOpenChange(false);
              } catch {
                // Error stays on the button; dialog stays open so the user can retry.
              }
            }}
            disabled={del.isPending}
          >
            {del.isPending ? "Removing…" : "Remove link"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
